import React from 'react'
import { Root, createRoot } from 'react-dom/client'
import { createPortal } from 'react-dom'

interface ToastProps {
  content: string
  delay?: number
}

const ToastModal = (props: ToastProps): JSX.Element => {
  return (
    <>
      {createPortal(
        <div
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-2 py-1.5 rounded z-[999] transition-all bg-black bg-opacity-75 text-white text-sm whitespace-nowrap"
          id="J_TOASTMODAL"
        >
          {props.content}
        </div>,
        document.body
      )}
    </>
  )
}

declare global {
  interface Window {
    toastState: boolean
    toastRoot: Root
  }
}

export default {
  show: (params: ToastProps) => {
    if (window.toastState) {
      return false
    }
    window.toastState = true
    if (!window.toastRoot) {
      const toastRoot = document.createElement('div')
      toastRoot.id = 'J_TOAST_PORTAL'
      document.body.appendChild(toastRoot)
      window.toastRoot = createRoot(toastRoot)
      window.toastRoot.render(<ToastModal {...params} />)
    } else {
      window.toastRoot.render(<ToastModal {...params} />)
    }
    setTimeout(() => {
      window.toastState = false
      window.toastRoot.render(null)
    }, params?.delay || 2000)
  },
}
